import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate } from '@angular/router';
import { SplendidCRMDFService } from './SplendidCRMDFService'

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private splendid: SplendidCRMDFService,
        private router: Router) { }

    canActivate() {
        if(!this.splendid.getIsLogued()){
            this.router.navigate(['login']);
            return false;
        }

        return true;
    }
}


// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-poliflex-pipeline/src/app/services/AuthGuardService.service.ts